export const COMMENT_PREFIXES = {
  ASSIGNEE_CHANGE: 'Assignee Change Reason:',
} as const;

export const isAssigneeChangeComment = (comment: string): boolean =>
  comment.startsWith(COMMENT_PREFIXES.ASSIGNEE_CHANGE);

export const filterTaskPerformanceComments = (comment: string): string =>
  isAssigneeChangeComment(comment) ? '' : comment;

export const createAssigneeChangeComment = (reason: string): string =>
  `${COMMENT_PREFIXES.ASSIGNEE_CHANGE} ${reason}`;
